const initialState = {
    matchingRuleNamesForSelectionBox: [],
    mappingMatchings: [],
    ruleData: [],
    allRulesDetails: [],
    predictedRule: []
};

export default initialState;